import { AsyncPipe, SlicePipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  output,
  inject,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'with-link',
  templateUrl: './with-link.component.html',
  styleUrls: ['./with-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterModule, TooltipModule, AsyncPipe, SlicePipe],
})
export class WithLinkComponent {
  private router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  keyName!: string;
  value!: any;
  uri: string;
  readonly onAction = output<{ action: string; columnData: any }>();

  onGoToRoute(url: string, columnData: any, canRedirect: boolean = true) {
    if (url && canRedirect)
      this.router.navigate([
        url,
        columnData.id || columnData.campaign_id || columnData.reason_id,
      ]);
    else this.onAction.emit({ action: 'edit', columnData });
  }
}
